"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    counterSizes: ()=>counterSizes,
    counterVariants: ()=>counterVariants,
    counterIconButtonVariants: ()=>counterIconButtonVariants,
    counterEmphasisVariants: ()=>counterEmphasisVariants,
    counterEmphases: ()=>counterEmphases,
    counterIconButtonTypes: ()=>counterIconButtonTypes,
    counterSizeVariants: ()=>counterSizeVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const counterIconButtonVariants = {
    primary: {
        add: 'primary',
        remove: 'secondary'
    },
    secondary: {
        add: 'secondary',
        remove: 'secondary'
    }
};
const counterIconButtonTypes = Object.keys(counterIconButtonVariants);
const counterSizeVariants = {
    sm: {
        root: 'w-24',
        ctaButton: 'w-24'
    },
    md: {
        root: 'w-32',
        ctaButton: 'w-32'
    },
    lg: {
        root: 'w-40',
        ctaButton: 'w-40'
    }
};
const counterSizes = Object.keys(counterSizeVariants);
const counterEmphasisVariants = {
    regular: {
        root: 'text-primary-13 disabled:text-primary-6'
    },
    medium: {
        root: 'text-primary-13 disabled:text-primary-6'
    },
    bold: {
        root: 'text-primary-1 disabled:text-primary-1/40'
    }
};
const counterEmphases = Object.keys(counterEmphasisVariants);
const counterVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        root: 'flex items-center justify-center gap-1',
        numericText: 'block min-w-0 flex-1 tabular-nums',
        ctaButton: ''
    },
    variants: {
        emphasis: counterEmphasisVariants,
        size: counterSizeVariants
    },
    compoundVariants: [],
    defaultVariants: {
        emphasis: 'regular',
        size: 'sm'
    }
});
exports.counterEmphases = __webpack_exports__.counterEmphases;
exports.counterEmphasisVariants = __webpack_exports__.counterEmphasisVariants;
exports.counterIconButtonTypes = __webpack_exports__.counterIconButtonTypes;
exports.counterIconButtonVariants = __webpack_exports__.counterIconButtonVariants;
exports.counterSizeVariants = __webpack_exports__.counterSizeVariants;
exports.counterSizes = __webpack_exports__.counterSizes;
exports.counterVariants = __webpack_exports__.counterVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "counterEmphases",
    "counterEmphasisVariants",
    "counterIconButtonTypes",
    "counterIconButtonVariants",
    "counterSizeVariants",
    "counterSizes",
    "counterVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
